import { AmountType } from '@shared/cards-types';

export const creditShared = {
    overview: {
        showOwner: true,
    },
    layout: {
        productInfo: {
            showBalanceAndOutstandingAmount: true,
            showOwner: true,
        },
    },
    supplementary: {
        allowHiddenCardImage: true,
    },
    functions: {
        payUp: {
            suggestionAmounts: [
                AmountType.DRAWN_AMOUNT,
                AmountType.REMAINING_OUTSTANDING_AMOUNT,
                AmountType.MINIMAL_MONTHLY_AMOUNT,
            ],
        },
    },
};
